import React, { useState, useEffect } from 'react';
import { Card } from 'customer_portal-ui-shared';
import { useAppSelector } from '../../hooks';
import { IRegulation } from '../../contracts/amendment.contract';
import { RegulationDropDown, RegulationPrint } from '../shared';
import { DocumentType, PrintMode } from '../../constants';
import { Typography } from '@mui/material';

const TrackerCriteriaSummary = () => {
    const regulations: IRegulation[] = useAppSelector((state) => state.Regulation.ByCriteria.Regulations) || [];
    const criteria = useAppSelector((state) => state.Criteria.TrackerCriteria);
    const [printMode, setPrintMode] = useState<string>('');

    useEffect(() => {
        if (printMode === PrintMode.Print || printMode === PrintMode.View) {
            RegulationPrint({ filteredRegulations: regulations, filters: criteria, documentType: DocumentType.Tracker, printMode });
            setPrintMode('');
        }
    }, [printMode, regulations, criteria]);

    if (regulations.length === 0) {
        return <div>No regulations available.</div>;
    }

    const amendmentsLength = regulations.flatMap((f) => f.Amendments).length;

    const data = {
        title: {
            content: (
                <>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                        The Regulatory Tracker is an interactive platform designed to provide the latest developments arising from the International Maritime Organization (IMO). The current version
                        has been updated to reflect the forthcoming requirements up to the IMO decisions in June 2025.
                    </Typography>

                    <h5 style={{ marginTop: '18px' }}>
                        Showing {amendmentsLength} amendments across {regulations.length} regulations.
                    </h5>
                </>
            )
        },
        body: (
            <div style={{ width: '100%' }}>
                <RegulationDropDown regulations={regulations} filters={criteria} documentType={DocumentType.Tracker} printMode={printMode} setPrintMode={setPrintMode} />
            </div>
        )
    };

    return (
        <div style={{ width: '100%' }}>
            <Card data={data} tag="h5" />
        </div>
    );
};

export default TrackerCriteriaSummary;
